import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/footballCard.css';

// constants
import {
    ALL_FOOTBALL_MARKETS,
    ASIAN_HANDICAP,
    AWAY_TEAM_GOALS,
    AWAY_TEAM_TO_SCORE,
    BOTH_TEAMS_SCORE,
    CORRECT_SCORE,
    CORRECT_SCORE_GROUP,
    DOUBLE_CHANCE,
    FIRST_TEAM_TO_SCORE,
    HALF_TIME_CORRECT_SCORE,
    HALF_TIME_FULL_TIME,
    HALF_TIME_RESULT,
    HANDICAP,
    HOME_TEAM_GOALS,
    HOME_TEAM_TO_SCORE,
    LAST_TEAM_TO_SCORE,
    MATCH_BETTING_BOTH_TEAMS_SCORE,
    TEAM_SCORECAST,
    TOTAL_GOALS,
    UNDER_OVER,
    WIN_DRAW_WIN,
    WINNING_MARGIN
} from '../constants/marketTypes';
// helpers
import {getMarketsByCode} from '../helpers/marketHelpers';
import {getText} from '../../../../../helpers/localization';
// containers
import Accordion from '../containers/accordion';
// components
import WinDrawWin from '../components/winDrawWin';
import WinDrawWinSoccer3 from '../components/winDrawWinSoccer3';
import CorrectScore from '../components/correctScore';
import CorrectScoreSoccer3 from '../components/correctScoreSoccer3';
import TotalGoals from '../components/totalGoals';
import TotalGoalsSoccer3 from '../components/totalGoalsSoccer3';
import DoubleChance from '../components/doubleChance';
import UnderOver from '../components/underOver';
import UnderOverSoccer3 from '../components/underOverSoccer3';
import AsianHandicap from '../components/asianHandicap';
import HandicapSoccer3 from '../components/handicapSoccer3';
import BothTeamsScore from '../components/bothTeamsScore';
import BothTeamsScoreSoccer3 from '../components/bothTeamsScoreSoccer3';
import HomeTeamGoals from '../components/homeTeamGoals';
import AwayTeamGoals from '../components/awayTeamGoals';
import MatchBettingBothTeamsScore from '../components/matchBettingBothTeamsScore';
import WinningMargin from '../components/winningMargin';
import CorrectScoreGroup from '../components/correctScoreGroup';
import HomeTeamToScore from '../components/homeTeamToScore';
import AwayTeamToScore from '../components/awayTeamToScore';
import FirstTeamToScore from '../components/firstTeamToScore';
import LastTeamToScore from '../components/lastTeamToScore';
import HalfTimeFullTime from '../components/halfTimeFullTime';
import TeamScorecast from '../components/teamScorecast';
import HalfTimeCorrectScore from '../components/halfTimeCorrectScore';
import HalfTimeResult from '../components/halfTimeResult';
import {showBetSummary} from '../../../helpers/betHelpers';
import OverlayContainer from './../../../containers/overlayContainer';
import {isSoccer3FootballEvent} from '../../../../../helpers/moduleHelpers';
import {collapseAllMarkets, expandAllMarkets} from "../actions/marketsActions";
import {expandCollapseMarket} from "../../football/actions/marketsActions";
import {OPERATOR} from '../../../../../constants/operator'

const mapStateToProps = (state, ownProps) => {
    return {
        selectedGameIndex: state.vpp.selectedGameIndex,
        games: state.vpp.games,
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        betHistoryBets: state.vpp.betHistoryBets,
        footballMarketsExpanded: state.vpp.footballMarketsExpanded,
        noMoreBetsEventList: state.vpp.noMoreBetsEventList,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        channelEventBets: state.vpp.channelEventBets
    };
};

class FootballCard extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            games: storeData.vpp.games,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            betHistoryBets: storeData.vpp.betHistoryBets,
            footballMarketsExpanded: storeData.vpp.footballMarketsExpanded,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            channelEventBets: storeData.vpp.channelEventBets
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                games: storeData.games,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
                betHistoryBets: storeData.vpp.betHistoryBets,
                footballMarketsExpanded: storeData.vpp.footballMarketsExpanded,
                noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                channelEventBets: storeData.vpp.channelEventBets,
            });
        }
    }

    _generateMarketUI(marketCode, selectedEvent, key) {
        let store = this.props.store;
        let marketList = selectedEvent.markets;
        let marketUI;
        let markets = getMarketsByCode(marketCode, marketList);
        let homeTeam = getText(this.state.events[this.state.selectedEventIndex].teamOne, store);
        let awayTeam = getText(this.state.events[this.state.selectedEventIndex].teamTwo, store);
        let marketName = getText(marketCode.name, store, [homeTeam, awayTeam]);
        let content;
        if (markets.length > 0) {
            switch (marketCode) {
                case WIN_DRAW_WIN:
                    content = isSoccer3FootballEvent(selectedEvent.eventType) ? (
                        <WinDrawWinSoccer3 callbacks={() => undefined} markets={markets} store={store}
                                           selectedEvent={selectedEvent} key={key}/>) : (
                        <WinDrawWin callbacks={() => undefined} markets={markets} store={store}
                                    selectedEvent={selectedEvent} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case CORRECT_SCORE:
                    content = isSoccer3FootballEvent(selectedEvent.eventType) ? (
                        <CorrectScoreSoccer3 callbacks={() => undefined} markets={markets} store={store}
                                             key={key}/>) : (
                        <CorrectScore callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case TOTAL_GOALS:
                    content = isSoccer3FootballEvent(selectedEvent.eventType) ? (
                        <TotalGoalsSoccer3 callbacks={() => undefined} markets={markets} store={store} key={key}/>) : (
                        <TotalGoals callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case DOUBLE_CHANCE:
                    content = (<DoubleChance callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                             markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case UNDER_OVER:
                    content = isSoccer3FootballEvent(selectedEvent.eventType) ? (
                        <UnderOverSoccer3 callbacks={() => undefined} markets={markets} store={store} key={key}/>) : (
                        <UnderOver callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case ASIAN_HANDICAP:
                    content = (<AsianHandicap callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                              markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case HANDICAP:
                    if (isSoccer3FootballEvent(selectedEvent.eventType)) {
                        content = (<HandicapSoccer3 callbacks={() => undefined} markets={markets} store={store}
                                                    selectedEvent={selectedEvent} key={key}/>);
                        marketUI = (<Accordion marketLabel={marketName} store={store} key={key} index={key}
                                               content={content}/>);
                    }
                    break;
                case BOTH_TEAMS_SCORE:
                    content = isSoccer3FootballEvent(selectedEvent.eventType) ? (
                        <BothTeamsScoreSoccer3 callbacks={() => undefined} markets={markets} store={store}
                                               key={key}/>) : (
                        <BothTeamsScore callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case HOME_TEAM_GOALS:
                    content = (<HomeTeamGoals callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                              markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case AWAY_TEAM_GOALS:
                    content = (<AwayTeamGoals callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                              markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case MATCH_BETTING_BOTH_TEAMS_SCORE:
                    content = (
                        <MatchBettingBothTeamsScore callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                                    markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case WINNING_MARGIN:
                    content = (<WinningMargin callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                              markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case CORRECT_SCORE_GROUP:
                    content = (<CorrectScoreGroup callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                                  markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case HOME_TEAM_TO_SCORE:
                    content = (<HomeTeamToScore callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                                markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case AWAY_TEAM_TO_SCORE:
                    content = (<AwayTeamToScore callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                                markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case FIRST_TEAM_TO_SCORE:
                    content = (<FirstTeamToScore callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                                 markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case LAST_TEAM_TO_SCORE:
                    content = (<LastTeamToScore callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                                markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case HALF_TIME_FULL_TIME:
                    content = (<HalfTimeFullTime callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                                 markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case TEAM_SCORECAST:
                    content = (<TeamScorecast callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                              markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case HALF_TIME_CORRECT_SCORE:
                    content = (<HalfTimeCorrectScore callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                                     markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case HALF_TIME_RESULT:
                    content = (<HalfTimeResult callbacks={() => undefined} homeTeam={homeTeam} awayTeam={awayTeam}
                                               markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                default:
                    break;
            }
        }
        return marketUI;
    }
    _toggleMarkets(){
        if (!OPERATOR.expandAllMarkets && window.innerWidth < 950) {
            this.props.store.dispatch(collapseAllMarkets());
            this.props.store.dispatch(expandCollapseMarket(0))
        }
        else{
            this.props.store.dispatch(expandAllMarkets());
        }
    }
    componentDidMount() {
        this._toggleMarkets();
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];

        let marketsUI;
        if (selectedEvent !== undefined && selectedEvent.markets && selectedEvent.markets.length) {
            marketsUI = ALL_FOOTBALL_MARKETS.map((mkt, index) => this._generateMarketUI(mkt, selectedEvent, index));
        }

        if (showBetSummary(this.props.showLoadingOverlay, selectedGame, selectedEvent, storeData.vpp.noMoreBetsEventList, this.state)) {
            marketsUI = '';
        }
        let overlay = <OverlayContainer store={this.props.store} showLoadingOverlay={this.props.showLoadingOverlay}/>

        return (
            <div id={'football_card'} className={style.mainContainer}>
                <div className={style.footballCard}>{overlay}{marketsUI}</div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(FootballCard);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/football/containers/footballCard.js